<template lang="pug">
  .loading
    .text GOOD-BYE 2018
    .bar
      .gage( :style="getPercent" )
</template>

<script>
export default {
  props: {
    loaded: Number,
    loadTotal: Number
  },

  watch: {
    loaded: function() {
      this.updateLoadStatus();
    },
    loadTotal: function() {
      this.updateLoadStatus();
    }
  },

  data() {
    return {};
  },

  computed: {
    getPercent() {
      let per = this.loaded / this.loadTotal;

      if (per > 1) per = 1;
      else if (per < 0) per = 0;

      return {
        transform: "scale( " + per + ", 1)"
      };
    }
  },

  methods: {
    updateLoadStatus() {}
  }
};
</script>

<style scoped lang="scss">
.loading {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  z-index: 99999;

  .text {
    font-family: "ELECNA", sans-serif;
    font-size: 6vw;
    letter-spacing: 0.5vw;
    margin: 1vh;
  }

  .bar {
    width: 50%;
    height: 30px;
    background-color: #999;

    .gage {
      width: 100%;
      height: 100%;
      transform-origin: left;
      background-color: #fff;
      transform: scale(0, 1);
    }
  }
}

@media screen and (min-width: 768px) {
  .loading {
    .text {
      font-size: 2vw;
      letter-spacing: 0.5vw;
      margin: 1vh;
    }

    .bar {
      width: 20%;
    }
  }
}
</style>
